export * from './acronym-icon.constant';
export * from './acronym-icon.component';
